__turbopack_context__.v({
  "accordion-container": "Accordion-module-scss-module___ydUaW__accordion-container",
  "accordion-item-container": "Accordion-module-scss-module___ydUaW__accordion-item-container",
  "button": "Accordion-module-scss-module___ydUaW__button",
  "content-container": "Accordion-module-scss-module___ydUaW__content-container",
});
